import React from 'react';
import ReactDOM from 'react-dom/client';
import Signup from './Signup'; // Import Signup component
import Verify from './Verify'; // Import Verify component
import './App.css'; // Import styles

// Function to get the current path
function getPath() {
  return window.location.pathname;
}

// Render the Signup component in the signup-root
const signupRoot = document.getElementById('signup-root');
if (signupRoot && getPath() === '/') {
  ReactDOM.createRoot(signupRoot).render(
    <React.StrictMode>
      <Signup />
    </React.StrictMode>
  );
}

// Render the Verify component in the verify-root only when the path is /verify
const verifyRoot = document.getElementById('verify-root');
if (verifyRoot && getPath() === '/verify') {
  ReactDOM.createRoot(verifyRoot).render(
    <React.StrictMode>
      <Verify />
    </React.StrictMode>
  );
}
